<app-dialog [title]="'Submit Plan to Seller Central'" [actions]="actions" (action)="dialogAction($event)" (close)="close()">
  <div class="container">

   <mat-card class="freemium" *ngIf="tabIndex === 0">
     <div class="freemium_img">
       <img class="freemium_img&#45;&#45;inner" src="assets/images/freemium.png" alt="freemium">
     </div>
     <span class="freemium_info">
      Upgrade or buy new credits to continue creating shipments.
     </span>
     <app-button [buttonSize]="'small'" (click)="upgrade()">Upgrade Now</app-button>
   </mat-card>

    <mat-tab-group [selectedIndex]="tabIndex">
      <mat-tab>
        <div class="input-container">
          <div class="warehouse">
            <label for="" class="input-container_label">From warehouse</label>
            <app-button
                    *ngIf="!warehouseExists"
                    [buttonStyle]="'text underline'"
                    [buttonSize]="'action'"
                    [buttonColor]="'primary'"
                    (click)="createNewWarehouse('New')"
            >Create New</app-button
            >
          </div>
          <mat-select
                  [formControl]="warehouse"
                  placeholder="Select Warehouse"
                  class="input-container_input input-container_input--select input-container_input--thin"
          >
            <mat-select-trigger>
                <span class="address">{{selectedWarehouse?.addressln1}} {{selectedWarehouse?.addressln2}}</span>
                <span class="state"> ({{selectedWarehouse?.city ? selectedWarehouse?.city + ',': ''}} {{selectedWarehouse?.state}})</span>
            </mat-select-trigger>
            <mat-option *ngFor="let warehouse of warehouses" [value]="warehouse">
              <span class="address">{{warehouse.name}}</span>
              <span  class="state"> ({{warehouse.city ? warehouse.city + ',': ''}} {{warehouse.state}})</span>
            </mat-option>
          </mat-select>
        </div>

        <div class="totals">
          <div class="totals_item">
            Items: {{itemCount}}
          </div>

          <div class="totals_item">
            Qty: {{qty}}
          </div>
        </div>
      </mat-tab>

      <mat-tab>
        <div class="container">
          <div class="spinner">
            <i class="fal fa-spinner fa-spin"></i>
          </div>
          <div class="action-text">
            <div class="action-text_line" [ngClass]="{'action-text_line--active': textIndex === 0}">Your feed has been submitted</div>
            <div class="action-text_line" [ngClass]="{'action-text_line--active': textIndex === 1}">Waiting for response from Amazon</div>
            <div class="action-text_line" [ngClass]="{'action-text_line--active': textIndex === 2}">Getting shipment information</div>
          </div>
        </div>
      </mat-tab>
      <mat-tab>
        <div class="container">
          <i class="check"></i>
          <div class="action-text">
            <div class="action-text_line action-text_line--active" >Plan successfully submitted</div>
          </div>
        </div>
      </mat-tab>
      <mat-tab>
        <div class="container">
          <i class="error"></i>
          <div class="action-text">
            <div class="action-text_line action-text_line--active" >Error planning your shipment</div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

</app-dialog>
